module.exports = __webpack_public_path__ + "assets/images/AmiraLogo.c32ec108e1206c47e68118bbfbbcf6b1.svg";